import web_common_area_getAreaDataByAreaType from '@/lib/data-service/default/web_common_area_getAreaDataByAreaType'
import web_common_area_getInlandAreaChildListByParentId from '@/lib/data-service/default/web_common_area_getInlandAreaChildListByParentId'
import web_buyer_findAuditAll from '@/lib/data-service/default/web_buyer_findAuditAll'
import web_buyer_findAuditFail from '@/lib/data-service/default/web_buyer_findAuditFail'
import Pagination from '@/component/base-pagination/index.vue'
export default {
  data () {
    return {
      loading: false,
      params: {
        currentPage: 1,
        pageSize: 10,
        userName: '',
        companyName: '',
        cityId: '',
        // regionId: '',
        provinceId: '',
        buyerType: '',
        buyerStatus: 0
      },
      userTypeList: [{value: '', label: '全部'}, {value: 1, label: '机票'}, {value: 2, label: '旅游'}, {value: '1+2', label: '机票+旅游'}],
      provinceList: [],
      cityList: [],
      activeName: 'unchecked',
      userList: [],
      uncheckTotal: 0,
      failureUserList: [], // 失败名单
      failureTotal: 0,
      dialogVisible: false,
      failDetail: {},
    }
  },
  components: {
    Pagination
  },
  created () {
  },
  mounted () {
    //this.getAreaDataByAreaType()
    //this.getUnchecked()
  },
  activated () {
    this.getAreaDataByAreaType()
    this.getUnchecked()
  },
  deactivated() {},
  destroyed () {
  },
  watch: {},
  computed: {},
  filters: {},
  methods: {
    handleFilter() {
      this.onSearch()
    },
    changeProvince(val) {
      this.params.cityId = ''
      this.cityList = []
      if (val !== '') {
        this.getCity(val)
      }
    },
    onSearch() {
      this.params.currentPage = 1
      if (this.activeName === 'unchecked') {
        this.getUnchecked()
      } else {
        this.getNotAllPass()
      }
    },
    onReset() {
      this.params = {
        currentPage: 1,
        pageSize: 10,
        userName: '',
        companyName: '',
        cityId: '',
        // regionId: '',
        provinceId: '',
        buyerType: '',
        buyerStatus: 0
      }
      this.onSearch()
    },
    // 获取省份
    getAreaDataByAreaType(areaType = 1) {
      web_common_area_getAreaDataByAreaType({areaType}).then(res => {
        this.provinceList = res
      })
    },
    // 获取城市
    getCity(id) {
      web_common_area_getInlandAreaChildListByParentId({id}).then(res => {
        this.cityList = res
      })
    },
    getUnchecked() {
      web_buyer_findAuditAll(this.params).then(res => {
        this.userList = res.pageResult.pageData
        this.uncheckTotal = res.pageResult.totalCount
      })
    },
    getNotAllPass() {
      web_buyer_findAuditFail(this.params).then(res => {
        this.failureUserList = res.pageResult.pageData
        this.failureTotal = res.pageResult.totalCount
      })
    },
    handleClick() {
      this.onSearch()
    },
    applicationTypeFormatter(val) {
      if (val.buyerType === '1') {
        return '机票'
      } else if (val.buyerType === '2') {
        return '旅游'
      } else {
        return '机票+旅游'
      }
    },
    handleCheck(val) {
      this.$router.push({
        name: 'admin-buyer-check',
        query: {
          id: val.buyerId
        }
      })
    },
    handleCheckReason(val) {
      this.failDetail = val
      this.dialogVisible = true
    },
    handleClose() {
      this.dialogVisible = false
    },
  }
}
/*
* export default {
  data () {
    return {}
  },
  components: {},
  created () {
  },
  mounted () {},
  activated () {
  },
  deactivated() {},
  destroyed () {
  },
  watch: {},
  computed: {},
  filters: {},
  methods: {
  }
}
*/
